import { IconAlertTriangle } from "@tabler/icons-react";
import { useVideoDownloadErrorStore } from "../../utils/store";

/**
 * Barra de erro exibida quando vídeos falham ao carregar do R2.
 * Fica fixa no rodapé e mostra a quantidade de vídeos que falharam.
 */
export const VideoErrorBar = () => {
	const failedVideoDownloads = useVideoDownloadErrorStore(
		(state) => state.failedVideoDownloads,
	);

	if (failedVideoDownloads.length === 0) {
		return null;
	}

	const count = failedVideoDownloads.length;
	const message =
		count === 1
			? "Falha ao carregar 1 vídeo"
			: `Falha ao carregar ${count} vídeos`;

	return (
		<div className="fixed bottom-0 left-0 right-0 bg-red-600 text-white p-3 z-50 flex items-center justify-center space-x-2">
			<IconAlertTriangle size={24} />
			<span className="font-medium">{message}</span>
		</div>
	);
};
